import { AuthGuard } from '@app/auth/auth.guard';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import {ApolloModule, APOLLO_OPTIONS} from 'apollo-angular';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {HttpLinkModule, HttpLink} from 'apollo-angular-link-http';
import { AppRoutingModule } from '@app/app.routing';
import { ComponentsModule } from '@app/layouts/components/components.module';
import { AppComponent } from '@app/app.component';
import {
  AgmCoreModule
} from '@agm/core';
import { AdminLayoutComponent } from '@app/layouts/admin-layout/admin-layout.component';
import { LoginLayoutComponent } from '@app/layouts/login-layout/login-layout.component';
import { GraphQLModule } from '@app/graphql.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Apollo } from 'apollo-angular';
import { ApolloLink, concat } from 'apollo-link';
import { HttpHeaders } from '@angular/common/http';
import { AuthInterceptor } from '@app/auth/auth.interceptor';
import { AuthModule } from '@app/auth/auth.module';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {MatTableModule} from '@angular/material/table';
import {EditTripuzarpComponent } from './dialogs/tripuzarp/tripuzarp.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import {MatCardModule} from '@angular/material/card';
import {MatToolbarModule} from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { MoconvoyComponent } from './dialogs/moconvoy/moconvoy.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatListModule} from '@angular/material/list';
import { LiberacargaComponent } from './dialogs/mocarga/liberacarga/liberacarga.component';
import { EmbarcacionesComponent } from './components/embarcacion/embarcaciones/embarcaciones.component'
import { MatPaginatorModule } from '@angular/material/paginator';
import { EmbarcacionComponent } from './components/embarcacion/embarcacion/embarcacion.component';
import {MatTabsModule} from '@angular/material/tabs';
import { CambiarClaveComponent } from './components/usuario/cambiar-clave/cambiar-clave.component';
import { UsuarioPerfilComponent } from './components/usuario/usuario-perfil/usuario-perfil.component';
import { EmbarcacionConcesionListComponent } from './components/embarcacion/embarcacion-concesion-list/embarcacion-concesion-list.component';
import { DescargarDatosComponent } from './components/descargar-datos/descargar-datos.component';
import { CertificacionesComponent } from './components/certificaciones/certificaciones.component';


@NgModule({
  exports: [ApolloModule, HttpLinkModule],
  imports: [
    BrowserAnimationsModule,
    NgxMaterialTimepickerModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
    MatTableModule,
    MatDatepickerModule,
    DatePickerModule,
    MatCardModule,
    MatToolbarModule,
    MatIconModule,
    BrowserModule,
    MatAutocompleteModule,
    MatListModule,
    MatPaginatorModule,
    MatTabsModule,
        AgmCoreModule.forRoot({
      apiKey: 'YOUR_GOOGLE_MAPS_API_KEY'
    }),
    AuthModule.forRoot(),
    HttpClientModule,
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    LoginLayoutComponent,
    EditTripuzarpComponent,
    MoconvoyComponent,
    LiberacargaComponent,
    EmbarcacionesComponent,
    EmbarcacionComponent,
    CambiarClaveComponent,
    UsuarioPerfilComponent,
    EmbarcacionConcesionListComponent,
    DescargarDatosComponent,
    CertificacionesComponent,
    
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    apollo: Apollo,
    httpLink: HttpLink
  ) {
    const http = httpLink.create({ uri: 'http://web.mintransporte.gov.co/rnf-zarpe-graphql/' });

    const authMiddleware = new ApolloLink((operation, forward) => {
      // add the authorization to the headers
      operation.setContext({
        headers: new HttpHeaders().set('Authorization', 'bearer ' + localStorage.getItem('token') || '')
      });

      return forward(operation);
    });

    apollo.create({
      link: concat(authMiddleware, http),
      cache: new InMemoryCache(),
      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'network-only',
        },
        query: {
          fetchPolicy: 'network-only',
          errorPolicy: 'all',
        },
        mutate: {
          errorPolicy: 'all',
        },
      },
    });
  }
 }
